import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import ModalVisible from "../CohortGroupSession/Modal/modal";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import "./index.scss";
import SessionGroupFeedbackModal from "../../../../common/groupSessionNotesModal";
import api from "../../../../common/dependencies/utils/Api";
import BasicModal from "../../../../common/summaryMentorModal/Modal";
import { Button as MaterialButton } from "@material-ui/core";
import ModalFilter2 from "../../../../common/modalFilter2";
import StartupPage from "./startupPage";
import DiscussionPage from "./discussionPage";
import { withRouter, useHistory, useParams, Link } from "react-router-dom";
import {
  COHORT_NAME_LIST,
  GROUP_SESSION_NAME_LIST,
  COHORT_PARTICULAR,
  MATCH_MENTOR_LIST,
} from "../../../../common/constants/ApplicationUrl";
import {
  getStepperTooltipData,
  getAdminDashCohortGraphData,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  cohortGroupSessionHoursFilter,
  postCohortDiscussionActivity,
} from "../dependencies/action";
import SessionsModal from "../../../../common/sessionsModal";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import blueDot from "../../../../../assets/svg/blueDot.svg";
import polygon1 from "../../../../../assets/svg/Polygon1.svg";
import polygon2 from "../../../../../assets/svg/Polygon2.svg";
import polygon3 from "../../../../../assets/svg/Polygon3.svg";
import ScheduleResources from "./scheduleResources";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  getNamesList,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import AboutPage from "./aboutPage";
import MentorPage from "./mentorPage";
import MatchMakingPage from "./matchMakingPage";
const CohortSessionList = (props) => {
  const {
    postCohortDiscussionActivity,
    cohortActivityData,
    getNamesList,
    getNamesListData,
    getCohortApplicationCounter,
    getTableCounterData,
    getTableData,
    listGroupSession,
    listGroupSessionPaginate,
    listGroupSessionData,
    detailsGroupSession,
    detailsGroupSessionData,
    cohortSessionNotesGiveFeedBack,
    cohortSessionNotesViewFeedBack,
    sessionFeedBackData,
    sessionNotesFeedBackData,
    cohortGroupSessionHoursData,
  } = props;
  const currentPage = localStorage.getItem("cohortWindow");
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [sessionModalData, setSessionModalData] = useState(null);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const html = document.getElementsByTagName("html")[0];
  const [cohortGroupSessionId, setCohortGroupSessionId] = useState("");
  const [feedbackMode, setFeedbackMode] = useState(false);
  const [showVideo, setShowVideo] = useState();
  const [videoUrl, setVideoUrl] = useState();
  const [videoArr, setVideoArr] = useState([]);
  const [newCohortid, setNewCohortid] = useState();
  const [clickModaldata, setClickmodaldata] = useState([]);
  const [selectedNavigation, setSelectedNavigation] = useState("");
  const params = useParams();
  useEffect(() => {
    let params = {
      userId: loggedIn?.id,
      fromInvitationList: false,
      sessionStatus: selectedStatus,
      pageFilter: {
        pageSize: 9,
        currentPage: 0,
      },
    };
    listGroupSession(params);
    setSelectedNavigation(0);
  }, []);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  // const [toggleMentor, setToggleMentor] = useState(false);
  const [headingCohort, setHeadingCohort] = useState();
  const [fromModule, setFromModule] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [taggingList, setTaggingList] = useState([]);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [isShown, setIsShown] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomChildData, setSessionMomChildData] = useState("");
  const [canDelete, setCanDelete] = useState(false);
  const [parentData, setIsParentData] = useState("");
  const [commonCohortId, setCommonCohortId] = useState("");
  const [mentorMarker, setMentorMarker] = useState("");
  const [startupMarker, setStartupMarker] = useState("");
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [discussionFlag, setDiscussionFlag] = useState("");
  const [data, setData] = useState();
  const [reloadFn, setReloadFn] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const { statusGroupSession } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };
  useEffect(() => {
    localStorage.removeItem("showPending");
    localStorage.removeItem("mentorDashboardHome");
    // localStorage.removeItem("startUpApplications");
    // localStorage.removeItem("mentorStartupRequest");
    // localStorage.removeItem("cohortProgram");
    // localStorage.removeItem("cohortApplication");
    localStorage.removeItem("toMentorAction");
    // localStorage.removeItem("cohortStartup");
    // localStorage.removeItem("cohortMentors");
    localStorage.removeItem("mentorRequests");
    localStorage.removeItem("activitySummary");
    localStorage.removeItem("activitySummary2");
    localStorage.removeItem("activitySummary3");
    localStorage.removeItem("activitySummary4");
    localStorage.removeItem("activitySummary5");
    localStorage.removeItem("activityCohortTotal");
    localStorage.removeItem("activityCohortDetails");
    localStorage.removeItem("mentorshipClosed");
    localStorage.removeItem("mentorshipScheduled");
    localStorage.removeItem("mentorshipTotal");
    localStorage.removeItem("mentorshipSession");
    localStorage.removeItem("startupMentorshipHours");
    localStorage.removeItem("startupRequestAccepted");
    localStorage.removeItem("startupRequestSent");
    localStorage.removeItem("MyCohortStartupDashboard");
    localStorage.removeItem("MyCohortMentorDashboard");
    localStorage.removeItem("cohortApplicationMentor");
  }, []);

  useEffect(() => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //   },
    // })

    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  // if (loginrole === "Mentor" || loginrole === "Admin") {
  //   localStorage.setItem("CohortGroupSession", "CohortGroupSession");
  // } else {
  //   localStorage.removeItem("CohortGroupSession");
  //   history.push("/startup-dashboard");
  // }
  useEffect(() => {
    if (reloadFn) {
      postCohortDiscussionActivity({ cohortId: params?.cohortId });
      loadFn();
      setTimeout(() => {
        loadFn();
      }, 2000);
    }
  }, [reloadFn]);

  useEffect(() => {
    if (currentPage == "resources") {
      setSelectedNavigation(2);
    } else if (currentPage == "discussion") {
      setSelectedNavigation(1);
    } else {
      setSelectedNavigation(0);
    }
  }, [currentPage]);

  useEffect(() => {
    if (
      cohortActivityData !== undefined &&
      cohortActivityData !== null &&
      cohortActivityData !== ""
    )
      setDiscussionFlag(cohortActivityData);
  }, [cohortActivityData]);
  const loadFn = () => {
    let paramData;
    const LoginRole =
      localStorage.getItem("SavedLoggedInData") &&
      JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
    if (LoginRole === "Mentor" || LoginRole === "Admin") {
      paramData = {
        id: params.cohortId,
        mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else if (LoginRole === "Startup") {
      paramData = {
        id: params.cohortId,
        startupId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      };
    } else {
      paramData = {
        id: params.cohortId,
      };
    }
    // axios({
    //   url: COHORT_PARTICULAR,
    //   method: "post",
    //   data: paramData,
    // })
    api
      .POST(COHORT_PARTICULAR, paramData)
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    loadFn();
  }, []);

  return (
    <>
      <div
        // className="mentorlistmaindiv"
        className="chrtgrpsessionadmindashmaindiv"
      >
        <div
          className="dashboard-main2 cohortgroupsessionsdiv"
          style={{ background: "none" }}
        >
          <div
            className="MentorDashboard-CreateCohort"
            style={{ display: "none" }}
          >
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
              <div
                className="dashboard-bottom-btn4 topbackbtnmentorlist"
                style={{ background: "transparent", border: "none" }}
              ></div>
              <BasicModal
                videoUrl={videoUrl}
                open={showVideo}
                setOpen={setShowVideo}
                videoList={videoArr}
                canDelete={canDelete}
              />
              {sessionModalOpen && (
                <SessionsModal
                  newCohortid={newCohortid}
                  clickModaldata={clickModaldata}
                  modalVisibility={sessionModalOpen}
                  setModalVisibility={setSessionModalOpen}
                  modalData={sessionModalData}
                  setModalOpen={setModalOpen}
                  openEditModal={setEditModalVisibility}
                  // parentData={setRefreshPage}
                  fromModule="groupSessions"
                  allMentorList={allMentorList}
                  allStartupList={allStartupList}
                  onBroadcastSelectionChange={onBroadcastSelectionChange}
                  setTaggingList={setTaggingList}
                  taggingList={taggingList}
                  setShowVideo={setShowVideo}
                  setVideoUrl={setVideoUrl}
                  setVideoArr={setVideoArr}
                  fromPage="groupPage"
                  refreshPage={setRefreshPage}
                />
              )}
              {modalOpen && (
                <CohortSummaryModal
                  setModalVisibility={setModalOpen}
                  fromModule={fromModule}
                  modalVisibility={modalOpen}
                  cohortId={modalData}
                  fromPage={"cohortSessions"}
                  groupSessionId={cohortGroupSessionId}
                />
              )}
              {modalVisibility2 && (
                <ModalFilter2
                  modalVisibility={modalVisibility2}
                  setModalVisibility={setModalVisibility2}
                  // sendToParent={setIsParentData}
                  showPurposeOfMentorship={true}
                  fromPage={"startUpDashboard"}
                  allCalendarData={true}
                />
              )}
              <ModalVisible
                modalOpen={scheduleModalOpen}
                allMentorList={allMentorList}
                allStartupList={allStartupList}
                // mentorshipId={params.mentorshipId}
                setModalOpen={setScheduleModalOpen}
                onBroadcastSelectionChange={onBroadcastSelectionChange}
                setTaggingList={setTaggingList}
                taggingList={taggingList}
                refreshPage={setRefreshPage}
                EditModalValue={false}
                openEditModal={setEditModalVisibility}
              />
            </div>
            {sessionMomModalOpen && sessionMomModalOpen === true && (
              <SessionGroupFeedbackModal
                modalVisibility={sessionMomModalOpen}
                setModalVisibility={setSessionMomModalOpen}
                postFeedBack={cohortSessionNotesGiveFeedBack}
                viewMode={feedbackMode} //true if view feedback, false if post feedback
                modalData={sessionMomChildData}
                parentData={setRefreshPage}
                updateStatus={statusGroupSession}
                fromPage={"groupPage"}
                cohortGroupId={cohortGroupSessionId}
                modalData2={sessionModalData}
              />
            )}
          </div>
          <div className="iconWith-heading cohortappiconwith">
            <div
              style={{
                width: "100%",
                display: "flex",
                marginLeft: "3.75rem",
                marginTop: "7rem",
                zIndex: "100",
              }}
            >
              <div className="newuserTooltip">
                <MaterialButton
                  className="topbackbtnactual top-btn"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (selectedNavigation != 0) {
                      setSelectedNavigation(0);
                    } else {
                      if (
                        currentPage == "about" ||
                        currentPage == "discussion" ||
                        currentPage == "resources"
                      ) {
                        localStorage.setItem(
                          "MyCohortMentorDashboard",
                          "MyCohortMentorDashboard"
                        );
                        history.push({
                          pathname: `/dashboard`,
                          state: "cohortForm",
                        });
                      } else {
                        history.push(`/cohort-programs/all/`);
                      }
                    }
                    // if (data?.requestStatus == "Accepted" ||
                    // data?.cohort?.cohortAdminId == loggedIn?.id) {
                    //   if(selectedNavigation == 3)
                    //   {
                    //     localStorage.setItem(
                    //       "MyCohortMentorDashboard",
                    //       "MyCohortMentorDashboard"
                    //     );
                    //     history.push({
                    //       pathname: `/dashboard`,
                    //       state: "cohortForm",
                    //     });
                    //   }
                    //   else{
                    //     history.push(`/cohort-programs/all/`)

                    //   }
                    // } else {
                    //   window.location.reload();
                    // }
                  }}
                  style={{ background: "#3ac2d7" }}
                >
                  {" "}
                  Back
                </MaterialButton>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    top: "50px",
                    width: "200px",
                    left: "71px",
                  }}
                >
                  Click to Go My Dashboard
                </span>
              </div>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        {headingCohort !== undefined &&
          headingCohort !== null &&
          headingCohort !== "" &&
          selectedNavigation !== 0 &&
          selectedNavigation !== 1 && (
            <div className="centralCohortHeading">{headingCohort}</div>
          )}

        <div>
          {selectedNavigation == 0 && (
            <div className="polygonLeft">
              <img src={polygon2} />
            </div>
          )}
          {selectedNavigation == 0 && (
            <div className="polygonRight2">
              <img src={polygon1} />
            </div>
          )}
          {selectedNavigation == 0 && (
            <div className="polygonRight">
              <img src={polygon3} />
            </div>
          )}
          <div className="col-md-11 display-center mobileviewcohortappli">
            {data !== undefined &&
              (data?.requestStatus == "Accepted" ||
                data?.cohort?.cohortAdminId == loggedIn?.id ||
                loggedIn?.role == "Admin") && (
                <div className="cohortSessionListBox row mobileviewmentorbelow">
                  <div className="row cohortSessionInnerBox">
                    <div className="d-flex  justify-content-between align-items-center">
                      <div
                        className="newuserTooltip"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedNavigation(0)}
                      >
                        <div
                          className={
                            selectedNavigation == 0
                              ? "cohortSessionBoxText2"
                              : "cohortSessionBoxText"
                          }
                        >
                          About
                        </div>
                        <span className="tooltiptext   tooltip-bottom group-01">
                          Click to View About
                        </span>
                      </div>
                      <div
                        className="newuserTooltip"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedNavigation(1)}
                      >
                        <div className="d-flex">
                          {discussionFlag && discussionFlag?.notify && (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div className="pendingStatusMarker" />
                            </div>
                          )}
                          <div
                            className={
                              selectedNavigation == 1
                                ? "cohortSessionBoxText2"
                                : "cohortSessionBoxText"
                            }
                          >
                            {/* cohortActivityData */}
                            Discussion Board
                          </div>
                        </div>{" "}
                        <span className="tooltiptext   tooltip-bottom group-01">
                          Click to View Discussion Board
                        </span>
                      </div>
                      <div
                        className="newuserTooltip"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedNavigation(2)}
                      >
                        <div
                          className={
                            selectedNavigation == 2
                              ? "cohortSessionBoxText2"
                              : "cohortSessionBoxText"
                          }
                        >
                          Schedule and Resources
                        </div>
                        <span
                          className="tooltiptext   tooltip-bottom group-01"
                          style={{ width: "300px" }}
                        >
                          Click to View Schedule and Resources
                        </span>
                      </div>
                      <div
                        className="newuserTooltip"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedNavigation(3)}
                      >
                        <div className="d-flex">
                          {mentorMarker &&
                            parentData?.cohort?.cohortAdminId ==
                              loggedIn?.id && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="pendingStatusMarker" />
                              </div>
                            )}
                          <div
                            className={
                              selectedNavigation == 3
                                ? "cohortSessionBoxText2"
                                : "cohortSessionBoxText"
                            }
                          >
                            Mentors
                          </div>
                        </div>
                        <span className="tooltiptext   tooltip-bottom group-01">
                          Click to View Mentors
                        </span>
                      </div>
                      <div
                        className="newuserTooltip"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSelectedNavigation(4)}
                      >
                        <div className="d-flex">
                          {startupMarker &&
                            parentData?.cohort?.cohortAdminId ==
                              loggedIn?.id && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="pendingStatusMarker" />
                              </div>
                            )}
                          <div
                            className={
                              selectedNavigation == 4
                                ? "cohortSessionBoxText2"
                                : "cohortSessionBoxText"
                            }
                          >
                            Startups
                          </div>
                        </div>
                        <span className="tooltiptext   tooltip-bottom group-01">
                          Click to View Startups
                        </span>
                      </div>
                      {parentData !== undefined &&
                        parentData !== null &&
                        parentData !== "" &&
                        (parentData?.cohort?.cohortAdminId == loggedIn?.id ||
                          loggedIn?.role == "Admin") && (
                          <div
                            className="newuserTooltip"
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedNavigation(5)}
                          >
                            <div
                              className={
                                selectedNavigation == 5
                                  ? "cohortSessionBoxText2"
                                  : "cohortSessionBoxText"
                              }
                            >
                              Matchmaking
                            </div>
                            <span className="tooltiptext   tooltip-bottom group-01">
                              Click to View Matchmaking
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              )}

            {/* const [mentorMarker,setMentorMarker] = useState("");
  const [startupMarker,setStartupMarker] = useState(""); */}

            {selectedNavigation == 0 ? (
              <AboutPage
                setSelectedNavigation={setSelectedNavigation}
                setHeadingCohort={setHeadingCohort}
                setIsParentData={setIsParentData}
                parentData={parentData}
                commonCohortId={commonCohortId}
                setCommonCohortId={setCommonCohortId}
                setMentorMarker={setMentorMarker}
                setStartupMarker={setStartupMarker}
                userStatus={data}
                setReloadFn={setReloadFn}
              />
            ) : selectedNavigation == 3 ? (
              <MentorPage
                setHeadingCohort={setHeadingCohort}
                setIsParentData={setIsParentData}
                parentData={parentData}
                commonCohortId={commonCohortId}
                setCommonCohortId={setCommonCohortId}
                setMentorMarker={setMentorMarker}
              />
            ) : selectedNavigation == 4 ? (
              <StartupPage
                setHeadingCohort={setHeadingCohort}
                setIsParentData={setIsParentData}
                parentData={parentData}
                commonCohortId={commonCohortId}
                setCommonCohortId={setCommonCohortId}
                setStartupMarker={setStartupMarker}
              />
            ) : selectedNavigation == 2 ? (
              <ScheduleResources
                setHeadingCohort={setHeadingCohort}
                setIsParentData={setIsParentData}
                parentData={parentData}
                commonCohortId={commonCohortId}
                setCommonCohortId={setCommonCohortId}
              />
            ) : selectedNavigation == 1 ? (
              <DiscussionPage
                setHeadingCohort={setHeadingCohort}
                setIsParentData={setIsParentData}
                parentData={parentData}
                commonCohortId={commonCohortId}
                setCommonCohortId={setCommonCohortId}
                setDiscussionFlag={setDiscussionFlag}
              />
            ) : (
              <MatchMakingPage parentData={parentData} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    listGroupSessionPaginate:
      state.MentorReducer.listCohortGroupSession.paginate,
    listGroupSessionData: state.MentorReducer.listCohortGroupSession.data,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
    invitedSessionList: state.MentorReducer.listSessionMemberList.data,
    invitedSessionListPaginate:
      state.MentorReducer.listSessionMemberList.paginate,
    groupSessionCounter:
      state.MentorReducer.listCohortGroupSessionCounters.data,
    sessionFeedBackData: state.MentorReducer.cohortViewFeedBack.data,
    sessionNotesFeedBackData:
      state.MentorReducer.cohortSessionNotesViewFeedBack,
    cohortGroupSessionHoursData: state.MentorReducer.cohortGroupSessionHours,
    cohortGroupSessionHoursFilteredData:
      state.MentorReducer.cohortGroupSessionHoursFilter,
    cohortCounterData: state.AdminMentorReducer.adminDashCohortCounter,
    cohortActivityData: state.MentorReducer.cohortDashboardActivity.data,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getNamesList,
  getCohortApplicationCounter,
  getStepperTooltipData,
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  getAdminDashCohortGraphData,
  cohortGroupSessionHoursFilter,
  postCohortDiscussionActivity,
})(withRouter(CohortSessionList));
